const style = { 
    issueDescriptionStyle: {height: 152},
};
export default style;
